import { Validators } from '@angular/forms';

export class BorrowerTypeModel {
  borrowerType = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  borrowerCount = {
    value: 1,
    validation: Validators.compose([
      Validators.required
    ])
  };
  // trustACN = {
  //   value: null,
  //   validation: Validators.compose([])
  // };
}
